import { inject, Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  Router,
  UrlTree,
} from '@angular/router';
import { ProjectService } from '../shared/services/project/project.service';

@Injectable({ providedIn: 'root' })
export class ProjectGuard implements CanActivate, CanActivateChild {
  private readonly projectService = inject(ProjectService);
  private readonly router = inject(Router);

  async check(): Promise<boolean | UrlTree> {
    const startupProject = await this.projectService.projectReady$;

    // openProject stages the project in pendingProject and only moves it to
    // currentProject once NavigationEnd fires — which is after this guard runs.
    // Ignoring pendingProject here bounces the very navigation that is opening
    // the project, so nothing can be opened from a state with no active project.
    const activeProject =
      this.projectService.pendingProject() ??
      this.projectService.currentProject() ??
      startupProject;

    if (activeProject !== null) {
      return true;
    }
    return this.router.createUrlTree(['/']);
  }

  canActivate(): Promise<boolean | UrlTree> {
    return this.check();
  }

  canActivateChild(): Promise<boolean | UrlTree> {
    return this.check();
  }
}
